import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'directories.filters-v2.main.flags.copy.success.title',
		defaultMessage: 'A copy of {name} was successfully created.',
		description:
			'Flag title. Flag is shown in Subscription modal when the request to create a copy of filter has succeeded',
	},
});

const copied = ({ name }: { name: string }): FlagConfiguration => ({
	type: 'success',
	title: [messages.title, { name }],
	isAutoDismiss: true,
	messageId: 'filters-main.flags.copy.flag.success',
	messageType: 'transactional',
});

export default copied;
